import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../hooks/useApi";
import { toast } from "sonner";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function AdminOffers() {
  const api = useApi();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["admin-offers"], queryFn: async () => (await api.get("/admin/offers")).data });
  const [edits, setEdits] = useState({});

  const save = async (id) => {
    const price = Number(edits[id]);
    if (!edits[id] || Number.isNaN(price) || price <= 0) {
      toast.error("Enter a price greater than $0.");
      return;
    }
    try {
      await api.patch(`/admin/offers/${id}`, { price });
      toast.success("Offer updated");
      qc.invalidateQueries({ queryKey: ["admin-offers"] });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update offer");
    }
  };

  return (
    <div data-testid="admin-offers-page">
      <h1 className="font-display text-display-xs mb-6">Offer &amp; Entitlement Configuration</h1>
      <div className="divide-y divide-border border-t border-b border-border">
        {data?.map((o) => (
          <div key={o.id} data-testid={`admin-offer-row-${o.id}`} className="py-3 flex items-center justify-between gap-4">
            <div>
              <p className="text-sm">{o.label}</p>
              <p className="text-xs text-foreground/70 uppercase">{o.product_type} · {o.status}</p>
              {o.storefront_price != null && (
                <p className="text-xs mt-1 flex items-center gap-1.5 text-foreground/70" data-testid={`admin-offer-sync-status-${o.id}`}>
                  {o.price_synced ? <CheckCircle2 className="w-3 h-3" /> : <AlertTriangle className="w-3 h-3" />}
                  {o.price_synced ? "synced with storefront" : `storefront shows $${o.storefront_price}`}
                </p>
              )}
            </div>
            <div className="flex items-center gap-2">
              <span className="text-white/70 text-sm">$</span>
              <input
                data-testid={`admin-offer-price-input-${o.id}`}
                defaultValue={o.price}
                onChange={(e) => setEdits((prev) => ({ ...prev, [o.id]: e.target.value }))}
                className="bg-black border border-white/15 w-20 px-2 py-1 text-sm"
              />
              <button data-testid={`admin-offer-save-${o.id}`} onClick={() => save(o.id)} className="text-xs uppercase text-brandAccent">Save</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
